/* ── Locale-aware link patching ──────────────────────────── */
/* Uses the real Shopify locale root (window.__localeRoot, set from routes.root_url
   in theme.liquid). This is authoritative — e.g. Chinese is "/zh" even though the
   iso_code is "zh-CN", so we must not derive the prefix from documentElement.lang. */
(function () {
  var root = window.__localeRoot || '/';
  if (!root || root === '/') return; // primary locale — links are already correct
  // Matches a leading locale segment like /de, /zh, /pt-pt. No real app path
  // (/collections, /pages, /products, /cart …) is a bare 2-letter segment, so this
  // never false-matches — and it guarantees we never stack a second prefix
  // (which produced broken /de/es/… URLs that 404'd in Search Console).
  var hasLocalePrefix = /^\/[a-z]{2}(-[a-z]{2,4})?(\/|$)/i;
  function patch() {
    document.querySelectorAll('a[href]').forEach(function (el) {
      var href = el.getAttribute('href');
      if (!href || href.charAt(0) !== '/') return; // only root-relative links
      if (hasLocalePrefix.test(href)) return;      // already locale-prefixed — never double up
      el.setAttribute('href', root + href);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
})();

/* Land at the top on every ordinary page view, even when Safari serves the page
   from its own cache (bfcache) instead of loading it fresh — which is the normal
   case for "You May Also Like", Recently Viewed, or any link back to a product
   already seen earlier in the session. Safari restores that cached page exactly
   as it was left, scroll position included, so without this a tap on a product
   card can silently reopen it scrolled to wherever the visitor left it last time,
   instead of at the top like a fresh page view.

   The one navigation where restoring the old scroll position IS what the visitor
   expects is a genuine back/forward — tapping the browser's own back button or
   using the edge-swipe gesture — so that's the one case this leaves alone, using
   the Navigation Timing API to tell the two apart. */
(function () {
  function isBackForward() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      if (entry) return entry.type === 'back_forward';
    } catch (e) {}
    try { return performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD; } catch (e) {}
    return false;
  }
  function releaseMenuLock() {
    // Also covers the older, narrower bug: the hamburger menu's scroll-lock left
    // stuck on (position: fixed) because the visitor navigated away — swipe-back,
    // tab switch — without tapping its close button, so `closeMenu` never ran.
    if (document.body.style.position === 'fixed') {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      delete document.body.dataset.luxScrollY;
    }
  }
  window.addEventListener('pageshow', function () {
    releaseMenuLock();
    if (!isBackForward()) window.scrollTo(0, 0);
  });
  // Belt and braces: clear the lock BEFORE the page can be cached at all, so a
  // stuck-open menu never gets baked into a bfcache snapshot in the first place.
  // pagehide (not beforeunload) is the event bfcache is designed around.
  window.addEventListener('pagehide', releaseMenuLock);
})();

document.addEventListener('DOMContentLoaded', function () {

  /* ── Scroll reveal ──────────────────────────────────────── */
  var revealItems = document.querySelectorAll('.luxury-reveal');
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px 60px 0px' });

  /* An observer watching the VIEWPORT can never see a card that is parked off to the
     right inside a horizontal carousel — You May Also Like, Recently Viewed, Best
     Sellers, the reviews row. Those cards kept the un-revealed state for the whole
     visit: fully transparent and sitting 36px low. Swiping the row then appeared to
     scroll it vertically as well as sideways, because what came into view was a card
     drawn below where it belonged and fading in from nothing.
     A card inside such a row is shown at once — the row's own section still animates
     in around it, so the effect on the page is unchanged. */
  function insideHorizontalScroller(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var ox = getComputedStyle(p).overflowX;
      if (ox === 'auto' || ox === 'scroll') return true;
    }
    return false;
  }
  revealItems.forEach(function (item) {
    if (insideHorizontalScroller(item)) item.classList.add('is-visible');
    else revealObserver.observe(item);
  });

  /* ── Luxury page body class ─────────────────────────────── */
  if (document.querySelector('.luxury-page')) {
    document.body.classList.add('luxury-homepage-active');
  }

  /* ── Mobile hamburger menu ──────────────────────────────── */
  var headers = document.querySelectorAll('.luxury-header');

  headers.forEach(function (header) {
    var nav = header.querySelector('.luxury-header__nav');
    if (!nav) return;

    // Create burger button
    var burger = document.createElement('button');
    burger.className = 'luxury-hamburger';
    burger.setAttribute('aria-label', 'Open navigation menu');
    burger.setAttribute('aria-expanded', 'false');
    burger.innerHTML =
      '<span class="luxury-hamburger__line"></span>' +
      '<span class="luxury-hamburger__line"></span>' +
      '<span class="luxury-hamburger__line"></span>';

    // Create close button inside nav overlay
    var closeBtn = document.createElement('button');
    closeBtn.className = 'luxury-nav-close';
    closeBtn.setAttribute('aria-label', 'Close navigation menu');
    closeBtn.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    nav.insertBefore(closeBtn, nav.firstChild);

    // Account link for the drawer: the icon in the pill is hidden on phones (no room),
    // so the same destination is offered here, worded by Liquid so it stays translated.
    var accUrl = header.getAttribute('data-account-url');
    if (accUrl && !nav.querySelector('.luxury-nav-account')) {
      var acc = document.createElement('a');
      acc.className = 'luxury-header__nav-link luxury-nav-account';
      acc.href = accUrl;
      acc.textContent = header.getAttribute('data-account-label') || 'Account';
      nav.appendChild(acc);
    }

    // Insert burger into header top actions
    var actions = header.querySelector('.luxury-header__actions');
    if (actions) {
      actions.insertBefore(burger, actions.firstChild);
    }

    function openMenu() {
      header.classList.add('is-menu-open');
      burger.setAttribute('aria-expanded', 'true');
      // iOS Safari: save scroll position then lock body in place
      var scrollY = window.scrollY;
      document.body.dataset.luxScrollY = scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      header.classList.remove('is-menu-open');
      burger.setAttribute('aria-expanded', 'false');
      nav.querySelectorAll('.luxury-nav-item.is-sub-open').forEach(function (it) { it.classList.remove('is-sub-open'); });
      nav.classList.remove('has-sub-open');
      var savedY = parseInt(document.body.dataset.luxScrollY || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedY);
    }

    burger.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);

    // Drawer (below 1440px) after Westwing, 2026-10-17: a category with sub-categories opens them in a
    // panel that slides over the list, headed by a "‹ Category" back row and a "View all" link to the
    // category itself. On computers the same links keep their hover dropdown and navigate normally.
    var drawerMq = window.matchMedia('(max-width: 1439px)');
    var viewAll = nav.getAttribute('data-view-all') || 'View all';
    nav.querySelectorAll('.luxury-nav-item').forEach(function (item) {
      var link = item.querySelector(':scope > .luxury-header__nav-link');
      var panel = item.querySelector(':scope > .luxury-nav-panel');
      if (!link || !panel) return;
      var head = document.createElement('div');
      head.className = 'lx-drw-head';
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'lx-drw-back';
      back.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg><span></span>';
      back.querySelector('span').textContent = link.textContent.trim();
      head.appendChild(back);
      var all = document.createElement('a');
      all.className = 'luxury-nav-panel__link lx-drw-all';
      all.href = link.getAttribute('href');
      all.textContent = viewAll;
      panel.insertBefore(all, panel.firstChild);
      panel.insertBefore(head, panel.firstChild);
      link.setAttribute('aria-haspopup', 'true');
      link.addEventListener('click', function (e) {
        if (!drawerMq.matches) return;
        e.preventDefault();
        item.classList.add('is-sub-open');
        nav.classList.add('has-sub-open');
        panel.scrollTop = 0;
        back.focus({ preventScroll: true });
      });
      back.addEventListener('click', function (e) {
        e.preventDefault();
        item.classList.remove('is-sub-open');
        nav.classList.remove('has-sub-open');
        link.focus({ preventScroll: true });
      });
    });

    // Close on real navigation: a plain link, a sub-category, the extra rows. A category that opens
    // its panel in the drawer does not close it.
    nav.querySelectorAll('.luxury-header__nav-link, .luxury-nav-panel__link').forEach(function (link) {
      link.addEventListener('click', function () {
        if (drawerMq.matches && link.parentElement && link.parentElement.classList.contains('luxury-nav-item')) return;
        closeMenu();
      });
    });

    // Mobile accordion: the chevron toggle expands/collapses a nav item's panel
    // without closing the whole drawer or navigating.
    nav.querySelectorAll('.luxury-nav-item__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = toggle.closest('.luxury-nav-item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    // Close when tapping the overlay background (works because nav is fixed fullscreen)
    nav.addEventListener('click', function (e) {
      if (e.target === nav) closeMenu();
    });
  });

  /* ── Collection sort: preserve price filter params ──────── */
  var sortSel = document.getElementById('luxury-sort-select');
  if (sortSel) {
    sortSel.addEventListener('change', function (e) {
      var sel = /** @type {HTMLSelectElement} */ (e.currentTarget);
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  /* ── Collection price filter: preserve sort + highlight ─── */
  var priceLinks = /** @type {NodeListOf<HTMLAnchorElement>} */ (document.querySelectorAll('#luxury-price-filters a'));
  if (priceLinks.length) {
    var curParams = new URL(window.location.href).searchParams;
    var curSort = curParams.get('sort_by');
    priceLinks.forEach(function (link) {
      if (curSort) {
        var u = new URL(link.href);
        u.searchParams.set('sort_by', curSort);
        link.href = u.toString();
      }
      var lp = new URL(link.href).searchParams;
      if ((lp.get('filter.v.price.gte') || '') === (curParams.get('filter.v.price.gte') || '') &&
          (lp.get('filter.v.price.lte') || '') === (curParams.get('filter.v.price.lte') || '')) {
        link.classList.add('luxury-coll-filter__range--active');
      }
    });
  }

  /* ── 3D tilt on collection/product cards (desktop pointers only).
     Style writes are batched to one per animation frame — updating on every
     raw mousemove caused stutter on lower-powered machines. ── */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.luxury-collection-card, .luxury-coll-card').forEach(function (card) {
      var frame = card.querySelector('.luxury-collection-card__frame, .luxury-coll-card__img-wrap');
      if (!frame) return;
      var raf = null, lastX = 0, lastY = 0;
      card.addEventListener('mousemove', function (e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (raf !== null) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = card.getBoundingClientRect();
          var x = (lastX - r.left) / r.width - 0.5;
          var y = (lastY - r.top) / r.height - 0.5;
          frame.style.transform = 'perspective(900px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 7).toFixed(2) + 'deg) scale(1.015)';
        });
      });
      card.addEventListener('mouseleave', function () {
        if (raf !== null) { cancelAnimationFrame(raf); raf = null; }
        frame.style.transform = '';
      });
    });
  }

  /* The furnace sparks over the homepage hero were removed on 2026-10-01 at the owner's request. */

  /* ── Newsletter popup: opens once after 16s, a dismissal is remembered
     for 30 days, subscribers never see it again. ── */
  (function () {
    var popup = document.getElementById('lux-popup');
    if (!popup) return;
    var KEY = 'vmg_popup';

    function read() {
      try { return localStorage.getItem(KEY); } catch (e) { return null; }
    }
    function write(v) {
      try { localStorage.setItem(KEY, v); } catch (e) { /* private mode */ }
    }
    function dismissed() {
      var v = read();
      if (!v) return false;
      if (v === 'sub') return true;
      var ts = parseInt(v, 10);
      return !isNaN(ts) && (Date.now() - ts) < 30 * 24 * 3600 * 1000;
    }
    function open() { popup.classList.add('is-open'); }
    function close() {
      popup.classList.remove('is-open');
      if (read() !== 'sub') write(String(Date.now()));
    }

    var closeBtn = popup.querySelector('.luxury-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    if (popup.dataset.success === 'true') {
      write('sub');
      open();
      return;
    }
    if (dismissed()) return;
    // Never interrupt someone who is already paying.
    if (/\/cart(\/|$)|\/checkouts?\//.test(location.pathname)) return;
    var shown = false;
    function openOnce() { if (shown || dismissed()) return; shown = true; open(); }
    setTimeout(openOnce, 16000);
    // Desktop exit intent: pointer leaves through the top of the window (towards tabs / address bar)
    // after the visitor has been on the page a few seconds — the last chance to keep a contact.
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var armedAt = Date.now() + 5000;
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && Date.now() > armedAt) openOnce();
      });
    }
  })();

  /* ── Language switcher dropdown ── */
  document.querySelectorAll('.luxury-lang-switcher').forEach(function(switcher) {
    var btn = switcher.querySelector('.luxury-header__lang');
    var form = switcher.querySelector('.luxury-lang-form');
    var input = switcher.querySelector('.luxury-lang-input');
    if (!btn || !input) return;
    /* The dropdown ships with an inline opacity:0/visibility:hidden so it can't flash open
       before the (deliberately non-blocking) stylesheet loads. Once this script runs, the
       stylesheet is in and its own .is-open rule can take over, so hand control back to it. */
    var dropdownEl = switcher.querySelector('.luxury-lang-dropdown');
    if (dropdownEl) { dropdownEl.style.opacity = ''; dropdownEl.style.visibility = ''; }
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = switcher.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
    switcher.querySelectorAll('.luxury-lang-option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        input.value = opt.dataset.locale;
        form.submit();
      });
    });
    document.addEventListener('click', function(e) {
      if (!switcher.contains(e.target) && switcher.classList.contains('is-open')) {
        switcher.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && switcher.classList.contains('is-open')) {
        switcher.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });

  /* ── Currency switcher dropdown (submits country_code; Shopify ties currency to market) ── */
  document.querySelectorAll('.luxury-currency-switcher').forEach(function(switcher) {
    var btn = switcher.querySelector('.luxury-header__currency');
    var form = switcher.querySelector('.luxury-currency-form');
    var input = switcher.querySelector('.luxury-currency-input');
    if (!btn || !input) return;
    var dropdownEl = switcher.querySelector('.luxury-currency-dropdown');
    if (dropdownEl) { dropdownEl.style.opacity = ''; dropdownEl.style.visibility = ''; }
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = switcher.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
    switcher.querySelectorAll('.luxury-currency-option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        input.value = opt.dataset.country;
        form.submit();
      });
    });
    document.addEventListener('click', function(e) {
      if (!switcher.contains(e.target) && switcher.classList.contains('is-open')) {
        switcher.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && switcher.classList.contains('is-open')) {
        switcher.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });

});

/* ── Recently viewed products (personalization, like 1stDibs / Nike) ────────
   Captures each product view into localStorage and renders a strip wherever
   #luxury-recent exists. Purely client-side; renders nothing if empty. */
(function () {
  var KEY = 'vmg_recent', MAX = 12, SHOW = 6;
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  // 1) Capture the current product (product pages only)
  var data = document.getElementById('luxury-rv-data');
  var current = '';
  if (data && data.dataset.handle) {
    current = data.dataset.handle;
    var item = {
      handle: data.dataset.handle,
      title: data.dataset.title || '',
      url: data.dataset.url || '',
      image: data.dataset.image || ''
    };
    var arr = read().filter(function (x) { return x && x.handle !== item.handle; });
    arr.unshift(item);
    write(arr.slice(0, MAX));
  }

  // 2) Render wherever a container exists (homepage, product page)
  var box = document.getElementById('luxury-recent');
  if (!box) return;
  var items = read().filter(function (x) { return x && x.handle && x.handle !== current; }).slice(0, SHOW);
  if (!items.length) return;
  var grid = box.querySelector('.luxury-recent__grid');
  if (!grid) return;
  var html = '';
  items.forEach(function (x, i) {
    var img = x.image ? ' style="background-image:url(\'' + String(x.image).replace(/'/g, '%27') + '\')"' : '';
    html += '<a class="luxury-recent__card" href="' + esc(x.url) + '">' +
      '<span class="luxury-recent__img"' + img + ' aria-hidden="true"></span>' +
      '<span class="luxury-recent__body">' +
      '<span class="luxury-recent__title">' + esc(x.title) + '</span>' +
      '<span class="luxury-recent__price" data-rv-price="' + i + '"></span>' +
      '</span></a>';
  });
  grid.innerHTML = html;
  box.hidden = false;

  // 3) Fetch each item's live price (in whatever currency the shopper currently has active)
  // instead of a value cached at view-time, which would go stale the moment they switch currency.
  //
  // The format is learned from a sample Liquid rendered with the money filter, not
  // produced by Intl: for euros in Italian Intl writes "1.900,00 €" while Shopify —
  // and therefore every other price on the site — writes "€1.900,00". Reading the
  // shop's own format keeps this strip identical to the cards next to it in every
  // language and every presentment currency.
  var fmt = (function (sample) {
    if (!sample) return null;
    var first = sample.search(/\d/);
    if (first < 0) return null;
    var last = sample.length - 1;
    while (last >= 0 && !/\d/.test(sample[last])) last--;
    var core = sample.slice(first, last + 1);
    var seps = core.replace(/\d/g, '');
    var lastSep = seps.slice(-1);
    // the sample is 12345.67, so a final group of two digits marks the decimal separator
    var tail = lastSep ? core.slice(core.lastIndexOf(lastSep) + 1) : '';
    var decimals = tail.length === 2 ? 2 : 0;
    return {
      prefix: sample.slice(0, first),
      suffix: sample.slice(last + 1),
      decimal: decimals ? lastSep : '',
      thousands: decimals ? (seps.length > 1 ? seps.charAt(0) : '') : lastSep,
      decimals: decimals
    };
  })(box.dataset.moneySample);

  var currencyCode = box.dataset.currency;
  var locale = document.documentElement.lang || undefined;
  function money(cents) {
    var v = Math.abs(cents) / 100, sign = cents < 0 ? '-' : '';
    if (fmt) {
      var s = fmt.decimals ? v.toFixed(fmt.decimals) : String(Math.round(v));
      var parts = s.split('.');
      if (fmt.thousands) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thousands);
      return sign + fmt.prefix + parts.join(fmt.decimal) + fmt.suffix;
    }
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }).format(cents / 100);
    } catch (e) { return sign + v.toFixed(2); }
  }

  items.forEach(function (x, i) {
    fetch(x.url + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || typeof p.price !== 'number') return;
        var el = grid.querySelector('[data-rv-price="' + i + '"]');
        if (el) el.textContent = money(p.price);
      })
      .catch(function () {});
  });
})();

/* ── Wishlist ──────────────────────────────────────────────────────────────
   Saves pieces client-side (localStorage) so it works with no account and no
   paid app. The PDP heart toggles; /pages/wishlist renders whatever is stored. */
(function () {
  var KEY = 'vmg_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }
  function saved(handle) {
    return read().some(function (x) { return x && x.handle === handle; });
  }

  /* 1) PDP heart — toggle save/remove and reflect the state visually. */
  var btn = document.querySelector('.luxury-pdp__wishlist');
  if (btn) {
    var handle = btn.getAttribute('data-handle');
    var addLabel = btn.getAttribute('data-add-label') || 'Add to Wishlist';
    var savedLabel = btn.getAttribute('data-saved-label') || 'Saved';
    var labelEl = btn.querySelector('.luxury-pdp__wishlist-label');
    var iconEl = btn.querySelector('.luxury-pdp__wishlist-icon');

    var paint = function (isSaved) {
      btn.classList.toggle('is-saved', isSaved);
      btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      if (labelEl) labelEl.textContent = isSaved ? savedLabel : addLabel;
      if (iconEl) iconEl.setAttribute('fill', isSaved ? 'currentColor' : 'none');
    };
    paint(saved(handle));

    btn.addEventListener('click', function () {
      var items = read();
      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i] && items[i].handle === handle) { idx = i; break; }
      }
      if (idx > -1) {
        items.splice(idx, 1);
        paint(false);
      } else {
        items.unshift({
          handle: handle,
          title: btn.getAttribute('data-title'),
          url: btn.getAttribute('data-url'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price')
        });
        paint(true);
      }
      write(items);
    });
  }

  /* 2) Wishlist page — render the saved pieces, allow removal in place. */
  var grid = document.getElementById('luxury-wishlist-grid');
  if (!grid) return;
  var emptyEl = document.getElementById('luxury-wishlist-empty');
  var removeLabel = grid.getAttribute('data-remove-label') || 'Remove';

  function render() {
    var items = read().filter(function (x) { return x && x.handle; });
    if (!items.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    grid.hidden = false;

    var html = '';
    items.forEach(function (x) {
      var imgStyle = x.image
        ? ' style="background-image:url(\'' + String(x.image).replace(/'/g, '%27') + '\')"'
        : '';
      html +=
        '<article class="luxury-wish-card">' +
          '<a class="luxury-wish-card__link" href="' + esc(x.url) + '">' +
            '<span class="luxury-wish-card__img"' + imgStyle + ' aria-hidden="true"></span>' +
            '<span class="luxury-wish-card__body">' +
              '<span class="luxury-wish-card__title">' + esc(x.title) + '</span>' +
              (x.price ? '<span class="luxury-wish-card__price">' + esc(x.price) + '</span>' : '') +
            '</span>' +
          '</a>' +
          '<button type="button" class="luxury-wish-card__remove" data-handle="' + esc(x.handle) + '" aria-label="' + esc(removeLabel) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</article>';
    });
    grid.innerHTML = html;
  }

  grid.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('.luxury-wish-card__remove') : null;
    if (!rm) return;
    var h = rm.getAttribute('data-handle');
    write(read().filter(function (x) { return x && x.handle !== h; }));
    render();
  });

  render();
})();

/* ── Certificate verification ───────────────────────────────────────────────
   Turns the self-issued Certificate of Authenticity into something a buyer can
   actually check. The registry is embedded in the page (no personal data — only
   what is already printed on the certificate), so the lookup is instant.
   `?ref=VMG-2026-0142` verifies on load, which is what the QR code on the
   certificate points at. */
(function () {
  var form = document.getElementById('luxury-verify-form');
  if (!form) return;

  var dataEl = document.getElementById('vmg-certificates');
  var input = document.getElementById('vmg-ref');
  var box = document.getElementById('luxury-verify-result');
  var s = document.querySelector('.luxury-verify-strings');
  if (!dataEl || !input || !box || !s) return;

  var certs;
  try { certs = JSON.parse(dataEl.textContent); } catch (e) { certs = []; }

  var t = function (name) { return s.getAttribute('data-' + name) || ''; };

  function esc(v) {
    var d = document.createElement('div');
    d.textContent = v == null ? '' : v;
    return d.innerHTML;
  }
  // "vmg 2026 0142", "VMG-2026-0142" and "vmg20260142" are the same reference.
  function key(v) {
    return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  var index = {};
  certs.forEach(function (c) {
    if (c && c.ref) index[key(c.ref)] = c;
  });

  function row(label, value) {
    if (!value) return '';
    return '<div class="luxury-verify-card__row"><dt>' + esc(label) + '</dt><dd>' + esc(value) + '</dd></div>';
  }

  function render(ref) {
    var c = index[key(ref)];
    box.hidden = false;

    if (!c) {
      box.className = 'luxury-verify-result is-notfound';
      box.innerHTML =
        '<div class="luxury-verify-card">' +
          '<span class="luxury-verify-card__seal luxury-verify-card__seal--no" aria-hidden="true">' +
            '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>' +
          '</span>' +
          '<h2 class="luxury-verify-card__title">' + esc(t('notfound')) + '</h2>' +
          '<p class="luxury-verify-card__sub">' + esc(t('notfound-sub')) + '</p>' +
          '<a class="luxury-button luxury-button--outline" href="' + esc(t('contact-url')) + '">' + esc(t('contact-cta')) + '</a>' +
        '</div>';
      return;
    }

    box.className = 'luxury-verify-result is-verified';
    var img = c.image
      ? '<span class="luxury-verify-card__img" style="background-image:url(\'' + String(c.image).replace(/'/g, '%27') + '\')" aria-hidden="true"></span>'
      : '';
    var link = c.url
      ? '<a class="luxury-button luxury-button--outline" href="' + esc(c.url) + '">' + esc(t('view-piece')) + '</a>'
      : '';

    box.innerHTML =
      '<div class="luxury-verify-card">' +
        '<span class="luxury-verify-card__seal" aria-hidden="true">' +
          '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>' +
        '</span>' +
        '<h2 class="luxury-verify-card__title">' + esc(t('verified')) + '</h2>' +
        '<p class="luxury-verify-card__sub">' + esc(t('verified-sub')) + '</p>' +
        '<div class="luxury-verify-card__body">' +
          img +
          '<dl class="luxury-verify-card__rows">' +
            row(t('f-reference'), c.ref) +
            row(t('f-piece'), c.title) +
            row(t('f-technique'), c.technique) +
            row(t('f-dimensions'), c.dimensions) +
            row(t('f-origin'), c.origin) +
            row(t('f-date'), c.date) +
          '</dl>' +
        '</div>' +
        link +
      '</div>';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = input.value.trim();
    if (!v) return;
    render(v);
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  // The QR code on the certificate lands here with the reference already in the URL.
  var params = new URLSearchParams(window.location.search);
  var fromUrl = params.get('ref');
  if (fromUrl) {
    input.value = fromUrl;
    render(fromUrl);
  }
})();

/* ── PDP quantity stepper: -/+ buttons adjust the number input; the form
   (main button or sticky mobile bar) reads its value on submit. ── */
(function () {
  var qtyInput = document.querySelector('.luxury-pdp__qty-input');
  if (!qtyInput) return;
  var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
  document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = (parseInt(qtyInput.value, 10) || min) - 1;
      qtyInput.value = v < min ? min : v;
    });
  });
  document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || min) + 1;
    });
  });
  qtyInput.addEventListener('change', function () {
    var v = parseInt(qtyInput.value, 10);
    qtyInput.value = (!v || v < min) ? min : v;
  });
})();

/* In a right-to-left page the carousel's content runs from the right edge
   leftwards, so scrolling "forward" means a negative scrollBy. Without this the
   next button pushes toward an edge that has no content and appears dead. */
var LUX_SCROLL_DIR = document.documentElement.getAttribute('dir') === 'rtl' ? -1 : 1;

/* ── Best Sellers horizontal scroller: arrow buttons scroll by ~one
   viewport-width; touch/trackpad swipe already works natively. ── */
(function () {
  var scroller = document.getElementById('luxury-bestsellers-scroller');
  if (!scroller) return;
  var prevBtn = document.querySelector('[data-bs-prev]');
  var nextBtn = document.querySelector('[data-bs-next]');
  function scrollByPage(dir) {
    scroller.scrollBy({ left: dir * LUX_SCROLL_DIR * scroller.clientWidth * 0.9, behavior: 'smooth' });
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });
})();

/* ── Collections carousel: same arrow-scroll pattern as Best Sellers. ── */
(function () {
  var scroller = document.getElementById('luxury-collections-scroller');
  if (!scroller) return;
  var prevBtn = document.querySelector('[data-coll-prev]');
  var nextBtn = document.querySelector('[data-coll-next]');
  function scrollByPage(dir) {
    scroller.scrollBy({ left: dir * LUX_SCROLL_DIR * scroller.clientWidth * 0.9, behavior: 'smooth' });
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });
})();

/* ── Full-screen photo viewer (2026-09-30), shared by every page ──
   Any element with data-lx-full="<large image url>" opens it in a <dialog>. The article
   template ships the dialog in its markup; elsewhere it is created on first use, with the
   close label taken from the nearest [data-lx-close]. Escape, the × and a click on the dark
   area close it; focus returns to the photo. */
(function () {
  var box = null, img = null, last = null;
  function ensure(label) {
    box = document.getElementById('lx-lightbox');
    if (!box) {
      box = document.createElement('dialog');
      box.className = 'lx-lightbox';
      box.id = 'lx-lightbox';
      box.innerHTML = '<button type="button" class="lx-lightbox__close">&times;</button><img class="lx-lightbox__img" alt="">';
      box.querySelector('.lx-lightbox__close').setAttribute('aria-label', label || 'Close');
      document.body.appendChild(box);
    }
    img = box.querySelector('.lx-lightbox__img');
    if (!box.getAttribute('data-bound')) {
      box.setAttribute('data-bound', '1');
      box.addEventListener('click', function (e) { if (e.target !== img) box.close(); });
      box.addEventListener('close', function () { if (last) last.focus(); });
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-lx-full]') : null;
    if (!t) return;
    var holder = t.closest('[data-lx-close]');
    ensure(holder ? holder.getAttribute('data-lx-close') : '');
    if (typeof box.showModal !== 'function' || box.open) return;
    var inner = t.querySelector('img');
    img.src = t.getAttribute('data-lx-full');
    img.alt = inner ? inner.alt : '';
    last = t;
    box.showModal();
  });
})();

/* ── Product cards (2026-09-30) ──
   1) Second photo on hover: created on the first hover of each card, on devices with a
      real pointer only, so phones never download it. It fades in once loaded.
   2) Wishlist heart on the card: same storage and format as the PDP heart and
      /pages/wishlist ({handle,title,url,image,price} objects under vmg_wishlist). */
(function () {
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine) {
    document.addEventListener('pointerover', function (e) {
      var wrap = e.target.closest ? e.target.closest('.luxury-coll-card__img-wrap[data-img2]') : null;
      if (!wrap || wrap.getAttribute('data-img2-done')) return;
      wrap.setAttribute('data-img2-done', '1');
      var main = wrap.querySelector('.luxury-coll-card__img');
      var img = new Image();
      img.className = 'luxury-coll-card__img2';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      if (main && main.getAttribute('sizes')) img.sizes = main.getAttribute('sizes');
      img.srcset = wrap.getAttribute('data-img2-srcset') || '';
      img.src = wrap.getAttribute('data-img2');
      img.onload = function () { img.classList.add('is-loaded'); };
      var overlay = wrap.querySelector('.luxury-coll-card__hover-overlay');
      wrap.insertBefore(img, overlay || null);
    });
  }

  var KEY = 'vmg_wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function indexOf(items, handle) {
    for (var i = 0; i < items.length; i++) { if (items[i] && items[i].handle === handle) return i; }
    return -1;
  }
  function paint(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? (btn.getAttribute('data-label-remove') || '') : (btn.getAttribute('data-label-add') || ''));
  }
  var hearts = document.querySelectorAll('.lx-card__heart');
  if (!hearts.length) return;
  var items = read();
  for (var i = 0; i < hearts.length; i++) paint(hearts[i], indexOf(items, hearts[i].getAttribute('data-handle')) > -1);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.lx-card__heart') : null;
    if (!btn) return;
    e.preventDefault();
    var list = read(), h = btn.getAttribute('data-handle'), at = indexOf(list, h);
    if (at > -1) { list.splice(at, 1); paint(btn, false); }
    else {
      list.unshift({ handle: h, title: btn.getAttribute('data-title'), url: btn.getAttribute('data-url'), image: btn.getAttribute('data-image'), price: btn.getAttribute('data-price') });
      paint(btn, true);
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 260);
    }
    write(list);
  });
})();

/* ── "Accendi le luci" (2026-10-17) ──
   Lighting collections: the switch in the filter bar puts every lamp's "lights on" photo
   (data-lit on the card, assets/lit-<handle>.jpg) over its studio photo. The pictures are
   created on the first switch-on only and load lazily; the choice is remembered while the
   visitor browses (vmg_lights). */
(function () {
  var btn = document.getElementById('lx-lights');
  if (!btn) return;
  var KEY = 'vmg_lights';
  function addLit() {
    var wraps = document.querySelectorAll('.luxury-coll-card__img-wrap[data-lit]');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap.getAttribute('data-lit-done')) continue;
      wrap.setAttribute('data-lit-done', '1');
      var main = wrap.querySelector('.luxury-coll-card__img');
      var img = new Image();
      img.className = 'luxury-coll-card__img-lit';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      img.loading = 'lazy';
      img.style.setProperty('--lit-d', (Math.min(i, 7) * 70) + 'ms');
      if (main && main.getAttribute('sizes')) img.sizes = main.getAttribute('sizes');
      img.srcset = wrap.getAttribute('data-lit-srcset') || '';
      img.src = wrap.getAttribute('data-lit');
      img.onload = function () { this.classList.add('is-loaded'); };
      if (main && main.nextSibling) wrap.insertBefore(img, main.nextSibling); else wrap.appendChild(img);
    }
  }
  function set(on, save) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on) addLit();
    document.documentElement.classList.toggle('lx-lit-on', on);
    if (save) { try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {} }
  }
  btn.addEventListener('click', function () { set(btn.getAttribute('aria-pressed') !== 'true', true); });
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  if (saved === '1') set(true, false);
})();

/* ── Header that comes back on scroll-up (2026-10-17, below 1440px) ──
   Past 180px the header becomes a fixed bar hidden while scrolling down and shown again on the
   first scroll up; back near the top it returns to its place over the page. CSS in
   luxury-homepage.css ("Header that comes back on scroll-up"). */
(function () {
  var h = document.querySelector('.luxury-header--absolute');
  if (!h || !window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 1439px)');
  var lastY = window.scrollY || 0, ticking = false;
  function update() {
    ticking = false;
    var y = window.scrollY || 0;
    if (h.classList.contains('is-menu-open')) { lastY = y; return; }
    if (!mq.matches || y < 180) {
      h.classList.remove('is-stuck', 'is-up');
    } else {
      h.classList.add('is-stuck');
      if (y < lastY - 6) h.classList.add('is-up');
      else if (y > lastY + 6) h.classList.remove('is-up');
    }
    // Sticky bars further down the page (the collection filter bar) move below the header while it shows.
    var shown = h.classList.contains('is-stuck') && h.classList.contains('is-up');
    document.documentElement.style.setProperty('--lx-hdr-h', shown ? h.offsetHeight + 'px' : '0px');
    lastY = y;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
})();
